"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurPid = getCurPid;
exports.removeCurPid = removeCurPid;
exports.setCurPid = setCurPid;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
/*
 * @Author: Lanren
 * @Date: 2021-08-04 10:14:44
 * @LastEditTime: 2022-03-17 17:27:06
 * @LastEditors: Lanren
 * @Description: ______
 * @FilePath: \sdk-admin\src\utils\app.js
 * --------
 */

var CurPidKey = 'bipid';
function getCurPid() {
  return _jsCookie.default.get(CurPidKey) || '';
}
function setCurPid(pid) {
  return _jsCookie.default.set(CurPidKey, pid);
}
function removeCurPid() {
  return _jsCookie.default.remove(CurPidKey);
}